'use client'

import { useEffect } from 'react'
import { resumeLocationSharing, startLocationSharing } from '@/lib/location-service'
import { authenticatedFetch } from '@/lib/client-fetch'

type StoredUser = {
  id?: string
  type?: string
}

function getStoredUser(): StoredUser | null {
  try {
    const raw = localStorage.getItem('user')
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

async function syncDriverEnRouteOrders() {
  const user = getStoredUser()
  if (!user?.id || user.type !== 'driver') {
    console.log('[LocationServiceBoot] no driver session found')
    return
  }

  try {
    const response = await authenticatedFetch(
      `/api/orders?driverId=${encodeURIComponent(user.id)}&status=en_route`,
      { method: 'GET', headers: { 'Accept': 'application/json' } },
    )
    const text = await response.clone().text().catch(() => '')
    let data: any = null
    try { data = text ? JSON.parse(text) : null } catch {}

    if (!response.ok) {
      console.warn('[LocationServiceBoot] failed to fetch en-route orders', response.status, text.slice(0, 200))
      return
    }

    const orders = Array.isArray(data) ? data : Array.isArray(data?.orders) ? data.orders : []
    const orderIds = orders
      .filter((order: any) => order?.status === 'en_route')
      .map((order: any) => order.id)
      .filter(Boolean)

    console.log('[LocationServiceBoot] en-route order sync', { driverId: user.id, orderIds })
    await startLocationSharing(user.id, orderIds)
  } catch (error: any) {
    console.warn('[LocationServiceBoot] en-route sync failed', error?.message || error)
  }
}

/**
 * Drop this once in the root layout. It resumes location sharing
 * from localStorage on every app launch / page load — even after
 * the driver has logged out or the app was killed.
 */
export default function LocationServiceBoot() {
  useEffect(() => {
    resumeLocationSharing()
    syncDriverEnRouteOrders()
  }, [])
  return null
}
